import React, { Component } from "react";
import { withTranslation, Trans } from "react-i18next";

class Timer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      timerId: null,
      remaining: 0
    };

    this.checkIfTimerExpiredAndTriggerRetrieve = this.checkIfTimerExpiredAndTriggerRetrieve.bind(
      this
    );
  }

  componentDidMount() {
    this.startTimer();
  }

  componentWillUnmount(){
    clearInterval(this.state.timerId);
  }

  /**
   * timer başlat
   */
  startTimer() {
    if (this.state.timerId) return;
    const timerId = setInterval(() => {
      this.checkIfTimerExpiredAndTriggerRetrieve();
    }, 1000);
    this.setState({
      timerId,
      remaining: 5
    });
  }

  /**
   * her timer tickinde çalışır,
   * eğer remaining 0 olmuşsa timerı kapatır,
   * retrieve fonk çalıştırır
   */
  checkIfTimerExpiredAndTriggerRetrieve() {
    if (this.state.remaining > 0) {
      this.setState({
        remaining: this.state.remaining - 1
      });
    }
    if (this.state.remaining <= 0) {
      clearInterval(this.state.timerId);
      this.setState({
        timerId: null,
        remaining: 0
      });
      this.props.expireCallback && this.props.expireCallback();
    }
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        {this.state.timerId ? (
          <>
            <div style={{ marginTop: 16 }}>{t("noManualRefresh")}</div>
            <div style={{ marginTop: 16 }}>
              <Trans
                i18nKey="kunduz:autoRefreshIn"
                values={{
                  seconds: this.state.remaining
                }}
              />
            </div>
          </>
        ) : null}
      </div>
    );
  }
}

export default withTranslation("kunduz")(Timer);
